export default __webpack_public_path__ + "static/media/gallery-5.9efb8a80.jpg";